import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FastracDxGridWrapperComponent, FastracScreenBaseComponent } from '@bds/fastrac';
import { FastracColsService } from '@bds/services';
import { CommunicationService, nameof } from '@bds/core';
import { CarIdTransformService } from '@bds/helpers';
import { bdsGridModeType } from '@bds/components';
import { RailtracReportsService } from '../../railtrac-reports.service';
import { PageService } from '@bds/core';
import { ReportConstants } from '../../models/report-parameters.model';
import DataSource from 'devextreme/data/data_source';

@Component({
    selector: 'lib-rt-transit-time-rs-detail',
    templateUrl: './rt-transit-time-rs-detail.component.html',
    styleUrls: ['./rt-transit-time-rs-detail.component.css'],
})
export class RtTransitTimeRsDetailComponent
    extends FastracScreenBaseComponent
    implements OnInit, OnDestroy
{
    public gridId = 111;
    public gridMode: bdsGridModeType = 'single';
    public gridSource: any;
    public selectedRowKeys: Array<number> = [];
    public controlNames: string[] = ['Ship Begin Date', 'Ship End Date'];
    public displayReport: boolean = false;

    @ViewChild(FastracDxGridWrapperComponent) set wrapper(w: FastracDxGridWrapperComponent) {
        Promise.resolve().then(() => {
            const grid = w?.grid?.instance;
            if (!grid) {
                return;
            }
            grid.option('onRowDblClick', (e: any) => this.onRowDblClick(e));
        });
    }

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        public gridColumnService: FastracColsService,
        public communicationService: CommunicationService,
        public carIdTransformService: CarIdTransformService,
        public reportService: RailtracReportsService,
        public pageService: PageService,
    ) {
        super(router, route, gridColumnService, communicationService, carIdTransformService);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.pageService.setHeader('Transit Time By Route Segment Detail Report');

        this.customizeColumns = (columns: any[]) => {
            const datePipe = new DatePipe('en-US');
            const shipCol = columns.find((c) => c.dataField === 'ship_date_time');
            if (shipCol) {
                shipCol.dataType = 'date';
                shipCol.calculateDisplayValue = (rowData: any) => {
                    const value = rowData['ship_date_time'];
                    return value ? datePipe.transform(value, 'MM/dd/yyyy', 'UTC') : '';
                };
            }
            ['beg_date', 'end_date'].forEach((field) => {
                const col = columns.find((c) => c.dataField === field);
                if (col) {
                    col.dataType = 'datetime';
                    col.calculateDisplayValue = (rowData: any) => {
                        const value = rowData[field];
                        return value ? datePipe.transform(value, 'MM/dd/yyyy HH:mm', 'UTC') : '';
                    };
                }
            });
        };
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    onGetReportClick(event: any) {
        this.displayReport = true;
        this.gridSource = new DataSource(
            this.reportService.CreateAspNetDatastore(
                ReportConstants.ReportDataApiCall,
                this.gridId.toString(),
                event.startDate,
                event.endDate,
            ),
        );
    }

    onCancelClick() {
        this.displayReport = false;
    }

    onRowDblClick(e: any) {
        const ormId = e?.data?.orm_id;
        if (ormId == null) {
            return;
        }
        window.open(`/trips/detail/${ormId}#tripdetailsanchor`, '_blank');
    }
}
